import React from 'react';
import { ErrorMessage as FormikErrorMessage } from 'formik';
import styles from './ErrorMessage.module.css';

type ErrorMessageProps = { name: string };

const ErrorMessage = ({ name }: ErrorMessageProps) => (
    <FormikErrorMessage name={name}>{(msg) => <span className={styles.error}>{msg}</span>}</FormikErrorMessage>
);

export default ErrorMessage;
